/**
 * Which "add to desktop" picker is open, if any.
 *
 * The desktop right-click menu lives in DesktopChrome and fires imperatively,
 * but the picker itself is React state owned by DesktopGrid — this is the seam
 * between them. Kept out of osStore because it is transient UI state, not OS
 * state worth persisting.
 */
export type DesktopPickerKind = "app" | "widget";

type Listener = () => void;

class DesktopPickerStore {
  kind: DesktopPickerKind | null = null;
  private listeners = new Set<Listener>();

  subscribe = (fn: Listener): (() => void) => {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  };

  private emit() {
    for (const l of this.listeners) l();
  }

  open(kind: DesktopPickerKind) {
    this.kind = kind;
    this.emit();
  }

  close() {
    if (this.kind === null) return;
    this.kind = null;
    this.emit();
  }
}

export const desktopPicker = new DesktopPickerStore();
